module.exports = __webpack_public_path__ + "img/11_2024_08_23.b9b9dca3.png";